import { Link } from "react-router-dom";
import construction from '../assets/construction.jpeg';


import heroImage from '../assets/deliverance icon.jpg';
import { io } from "socket.io-client";
import { useEffect, useState } from "react";
const API_BASE_URL = "https://church-backend-48tj.onrender.com";



function ConstructionPage() {


  const [constructions,setConstructions]=useState([]);





    
               useEffect(() => {
                  // socket live adds
                  const socket = io(API_BASE_URL, { transports: ['websocket'] });
                  socket.on('connect', () => { /* connected */ });
                         socket.on('getconstruction', (prod) => { if (prod) setConstructions(prev => [prod, ...prev]); });
                          socket.on('updateconstruction', (prod) => { if (prod) setConstructions(prev => [prod, ...prev]); });
                       
          socket.on('deleteconstruction', (id) => {
             setConstructions(prev =>
                prev.filter(item => item._id !== id)
             );
          });
                  return () => socket.disconnect();
                }, []);
    
    
                
      
      const getConstructions = async () => {
          try {
              const response = await fetch(`${API_BASE_URL}/api/constructions`);
      
              if (!response.ok) {
                  throw new Error("Failed to fetch constructions");
              }
      
              const data = await response.json();

const sortedData = [...data].sort(
  (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
);

setConstructions(sortedData);
      
              setConstructions(sortedData);
      
          } catch (err) {
              console.error(err);
          }
      };



       
            useEffect(() => {
        getConstructions();
            }, []);
    
return(

<div className="construction-page">

{/* ================= HERO ================= */}

<section
className="construction-hero"
style={{
backgroundImage:`url(${heroImage})`
}}
>

<div className="construction-overlay"></div>

<div className="container construction-hero-content">

<span>

BUILDING PROJECT

</span>

<h1>

Building A Home
<br/>

For Future
<span> Generations.</span>

</h1>

<p>

Together we are building a place where lives will be transformed,
families restored and generations will worship God.

</p>

<div className="construction-buttons">



<a
href="https://wa.me/254113717090?text=Hello%20Word%20Revelation%20Church.%20I%20would%20like%20to%20know%20more%20about%20your%20church."
    target="_blank"
    rel="noopener noreferrer"
className="construction-secondary"
>

Contact Us

</a>

</div>

</div>

<div className="scroll-indicator">

<div></div>

</div>

</section>

{/* ================= VISION ================= */}

<section className="vision-section">

<div className="container vision-grid">

<div className="vision-image">

<img

src={construction}

alt="Church Construction"

/>

</div>

<div className="vision-content">

<span>

OUR VISION

</span>

<h2>

Building More Than
A Church Building

</h2>

<p>

Every brick laid is part of a greater vision.

We are creating a welcoming place where people
can worship freely, children can grow in Christ,
young people can discover purpose and families
can experience God's love.

</p>

<p>

This project is not simply about construction.

It is about building a spiritual home that will
serve our community for generations.

</p>

</div>

</div>

</section>


{/* ================= GALLERY ================= */}

<section className="construction-gallery">

<div className="container">

<div className="section-heading">

<span>

PROJECT GALLERY

</span>

<h2>

Our Journey
In Pictures

</h2>

</div>

<div className="gallery-grid">

{

constructions.map((item,index)=>(

<div

className={`gallery-item gallery-${index}`}

key={item._id}

>

<img

src={item.image}

alt="Construction"

/>

<span>{item.title}</span>

</div>

))

}

</div>

</div>

</section>

{/* ================= SUPPORT ================= */}

<section className="support-section" id="support">

<div className="container">

<div className="support-grid">

<div className="support-content">

<span>

SUPPORT THE VISION

</span>

<h2>

Every Contribution
Builds Tomorrow.

</h2>

<p>

Whether large or small, every gift helps us
build a place where lives will be transformed,
families strengthened and generations will
experience God's love.

</p>

<ul>

<li>✔ Secure M-PESA Giving</li>

<li>✔ Every Contribution Matters</li>

<li>✔ Transparent Church Project</li>

<li>✔ Building For Future Generations</li>

</ul>

</div>

<div className="support-card">

<div className="support-card-top">

<h3>M-PESA</h3>

<div>

❤

</div>

</div>

<div className="support-number">

<small>PAYBILL NUMBER</small>

<h1>400222</h1>

</div>

<div className="support-account">

<small>ACCOUNT</small>

<h1>1865849#</h1>

</div>

<div className="support-footer">

Thank you for partnering with us.

</div>

</div>

</div>

</div>

</section>

{/* ================= SCRIPTURE ================= */}

<section className="scripture-banner">

<div className="scripture-overlay"></div>

<div className="container">

<h2>

"Unless the Lord builds the house,
the builders labor in vain."

</h2>

<p>

Psalm 127:1

</p>

</div>

</section>

{/* ================= CTA ================= */}

<section className="construction-final">

<div className="container">

<h2>

Thank You For
Building With Us.

</h2>

<p>

Together we are creating a place where
future generations will worship,
grow and encounter Jesus Christ.

</p>

<a

href="https://wa.me/254113717090?text=Hello%20Word%20Revelation%20Church.%20I%20would%20like%20to%20know%20more%20about%20your%20church."
    target="_blank"
    rel="noopener noreferrer"

className="construction-final-btn"

>

Contact The Church

</a>

</div>

</section>

</div>

)

}



export default ConstructionPage;
